<template>
  <div>
    <menu-presenter-tree
      :root-menu-id="rootMenuId"
      @openMenuContent="emit('openMenuContent', $event)"
      @openResourcePreview="onOpenResourcePreview"
    />

    <resource-preview-dialog
      v-if="resourcePreviewDialog"
      :resourceId="resourcePreviewId"
      :previewDialog="resourcePreviewDialog"
      :previewSrc="resourcePreviewSrc"
      :previewTitle="resourcePreviewTitle"
      @closeDialog="onCloseResourcePreview"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { ApiMenuReadMenuItemDto, MenuId, ResourceId } from '@/venit/services/model/techpubs-cms';
import MenuPresenterTree from '@/venit/admin/menu-management/menu-presenter-content-tree.vue';
import ResourcePreviewDialog from '@/venit/components/resources/resource-preview-dialog.vue';

defineProps<{
  rootMenuId: MenuId;
}>();

const emit = defineEmits<{
  openMenuContent: [menuId: MenuId];
}>();

const resourcePreviewId = ref<ResourceId | null>(null);
const resourcePreviewDialog = ref(false);
const resourcePreviewSrc = ref<string | null>(null);
const resourcePreviewTitle = ref<string | null>(null);

const onOpenResourcePreview = (item: ApiMenuReadMenuItemDto) => {
  resourcePreviewId.value = { uuid: item.resourceId };
  resourcePreviewSrc.value = item.url;
  resourcePreviewTitle.value = item.name;
  resourcePreviewDialog.value = true;
};

const onCloseResourcePreview = () => {
  resourcePreviewDialog.value = false;
  resourcePreviewId.value = null;
  resourcePreviewSrc.value = null;
  resourcePreviewTitle.value = null;
};
</script>
